var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 8.25C1.12292 8.25 0.907118 8.16024 0.727604 7.98073C0.54809 7.80122 0.458333 7.58542 0.458333 7.33333V1.375H0V0.458333H2.29167V0H5.04167V0.458333H7.33333V1.375H6.875V7.33333C6.875 7.58542 6.78524 7.80122 6.60573 7.98073C6.42622 8.16024 6.21042 8.25 5.95833 8.25H1.375ZM5.95833 1.375H1.375V7.33333H5.95833V1.375ZM2.29167 6.41667H3.20833V2.29167H2.29167V6.41667ZM4.125 6.41667H5.04167V2.29167H4.125V6.41667Z",
    fill: "#E62D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBin);
export default __webpack_public_path__ + "static/media/red-bin.5d03637cee4b5cec92eb3ed77cc346b5.svg";
export { ForwardRef as ReactComponent };